import {get, nth} from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AnchorNavigation from '../common/anchor_navigation/anchor_navigation';

const TOP_LEVEL_ANCHOR_LIMIT = 6;

export default class ChapterNavigation extends Component {

  chapterItems = () => {
    return this.props.widgetAnchorSections.reduce((acc, section) => {
      acc.size += 1;
      const data = {
        key: get(section, 'content.asset_id'),
        name: nth(get(section, 'content.resource').match(/name="(.*)"/), 1)
      };
      if (acc.size <= TOP_LEVEL_ANCHOR_LIMIT) {
        acc.landscape.push(data);
      } else {
        acc.dropdown.push(data);
      }
      return acc;
    }, { size: 0, landscape: [], dropdown: [] });
  };

  render() {
    return (
      <AnchorNavigation
        onCustomArticle={this.props.onCustomArticle}
        navItems={this.chapterItems()}
      />
    );
  }

}

ChapterNavigation.propTypes = {
  onCustomArticle: PropTypes.bool,
  widgetAnchorSections: PropTypes.arrayOf(PropTypes.object).isRequired
};
